/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { RiShoppingCartLine } from '@react-icons/all-files/ri/RiShoppingCartLine';
import { Typography, Button } from '@material-ui/core';
import { generateCategoryRoute } from 'spwa-ui-library/esm/utils/path';
import { navigate } from '@reach/router';
import { FormattedMessage, useIntl } from 'react-intl';
import css from '../CartButton/index.module.scss';
import ClassNames from 'classnames';
const { selectFirstCategory, setCurrentCat } = Slices.categorySlice;
const { fetchProductsByCategoryId } = Slices.productSlice;
const { getClusterId } = Slices.configSlice;
const { selectDefaultAddress } = Slices.addressSlice;

function DesktopEmptyCart({ countOfItems, isFloating }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const firstCategory = useSelector(selectFirstCategory);
  const clusterId = useSelector(getClusterId);
  const address = useSelector(selectDefaultAddress);
  const path = generateCategoryRoute({ category: firstCategory, locale: intl.locale });
  const exploreMenu = () => {
    if (path) {
      const categoryId = path?.split('/')?.[3];
      // dispatch(setCurrentCat(categoryId));
      dispatch(
        fetchProductsByCategoryId({
          id: categoryId,
          cluster: clusterId,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
          service: address.addressSubType || 'DELIVERY',
        })
      ).then((resp) => {
        navigate(path);
      });
    }
  };

  return (
    <>
      <div className={ClassNames(css.root, { [css.floating]: isFloating })}>
        <div className={css.dropdown}>
          <div className={css.dropdownBtn}>
            <RiShoppingCartLine className={css.cartIcon} />
            <div className={css.cartCount}>{countOfItems}</div>
          </div>
          <div className={css.dropdownContent}>
            <div className={css.emptyContainer}>
              <div className={css.emptyRoot}>
                <div className={css.noItem}>
                  <Typography variant="h5">
                    <FormattedMessage id="cart_empty" defaultMessage="Your Cart is Empty" />
                  </Typography>
                  <Typography variant="h6">
                    <FormattedMessage
                      id="cart_empty_desc"
                      defaultMessage="Please add some items from the menu"
                    />
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    fullWidth
                    onClick={exploreMenu}
                  >
                    <FormattedMessage id="explore_menu" defaultMessage="Explore Menu" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DesktopEmptyCart;
